import { HttpRequestGet, HttpRequestPost } from "../../service";
export interface IUPCImportItemProps {
  ImportId: string
  FileUrl: string
  Created: string
  Creator: string
  Status: string
  TotalProducts: number
}
export interface IValidateUpcImportRequestModel { }
export interface IEnqueueUpcImportRequestModel { }
export type IValidateResult = "Success" | "Warning" | "Failure"
export interface IValidateSummary {
  Title: string;
  Result: IValidateResult;
  Details: string[];
}
export interface IValidateUpcImportResponseModel {
  Id: string;
  Path: string;
  Result: IValidateResult;
  Summary: IValidateSummary[];
}

export function listUpcImports(
  success: (resp?: any) => void,
  failure: (resp?: any) => void
) {
  HttpRequestGet(
    `/upc/import/list`,
    () => undefined,
    (response: { Result: IUPCImportItemProps[] }) => success(response.Result),
    (error: any) => failure(error),
    true
  );
}

export function validateUpcImport(
  body: IValidateUpcImportRequestModel,
  callback: (resp: IValidateUpcImportResponseModel) => void,
  failAction: (resp?: any) => void
) {
  HttpRequestPost(
    "/upc/import/validate",
    () => undefined,
    (response: { Result: IValidateUpcImportResponseModel }) => {
      callback(response.Result);
    },
    (err: any) => failAction(err),
    true,
    body
  );
}

export function enqueueUpcImport(
  importId: string,
  callback: (resp: string) => void,
  failAction: (resp?: any) => void
) {
  HttpRequestPost(
    "/upc/import/enqueue/" + importId,
    () => undefined,
    (response: { Result: string }) => {
      callback(response.Result);
    },
    (err: any) => failAction(err),
    true,
    {}
  );
}

export function enqueueUpcExport(
  callback: (resp: string) => void,
  failAction: (resp?: any) => void
) {
  HttpRequestPost(
    "/upc/export",
    () => undefined,
    (response: { Result: string }) => {
      callback(response.Result);
    },
    (err: any) => failAction(err),
    true,
    {}
  );
}